/////////////////////////////////////////////////
// Manages the Buttons on mymuesli App
//
// Uses:
// app/templates/Layout/Button.php
// app/data/scss/interface/_buttons.scss
////////////////////////////////////////////////////////////
import Toggle from './Button/Toggle.es6';

(() => {
    class Button extends App.Component {
        constructor(container) {
            super(container);
            this.Toggle = new Toggle(this);
            this.bind();
        }

        /* Getters & Setters */
        get content() {
            if (this._content === undefined || this._content === null)
                this._content = this.container.querySelector('.button-content') ?
                    this.container.querySelector('.button-content').innerHTML : false;
            return this.Toggle.active
                ? this.container.dataset.toggleContent || this._content
                : this._content
        }
        set content(content) {
            let container = this.container.querySelector('.button-content');
            if (container && container.innerHTML !== content)
                container.innerHTML = content;
        }
        get type() {
            if (!this._type)
                this._type = this.container.dataset.type;
            return this.Toggle.active
                ? this.container.dataset.toggleType || this._type || ''
                : this._type
        }
        set type(type) {
            if (type && this.container.dataset.type !== type)
                this.container.dataset.type = type;
        }
        get icon() {
            if (this._icon === undefined)
                this._icon = this.container.querySelector('.icon') || false;
            return this.Toggle.active
                ? this.container.dataset.toggleIcon || this._icon.outerHTML || ''
                : this._icon === false ? '' : this._icon.outerHTML
        }
        set icon(icon) {
            let container = this.container.querySelector('.icon');
            if (container && icon !== container.outerHTML)
                container.outerHTML = icon;
        }

        bind() {
            let className = this.container.classList;
            this.container.addEventListener('mousedown',    () => className.add('click'));
            this.container.addEventListener('mouseup',      () => className.remove('click'));
            this.container.addEventListener('mouseout',     () => className.remove('click'));
            this.container.addEventListener('touchstart',   () => className.add('touch'), {passive: true});
            this.container.addEventListener('touchend',     () => className.remove('touch'));
            this.container.addEventListener('touchcancel',  () => className.remove('touch'));
            if (this.container.dataset.toggle)
                this.container.addEventListener('click',    () => this.Toggle.active = !this.Toggle.active);
            return this;
        }

        changeType(type) {
            this.container.dataset.type = type;
            return this;
        }

        changeToOriginalInstance() {
            this.Toggle.active = false;
            this.render();
            return this;
        }

        render() {
            ['content', 'type', 'icon'].forEach(i => this[i] = this[i]);
        }
    }
    App.Components.register('button, .button', Button);
})();

